import { LoginCallback as OktaLoginCallback } from '@okta/okta-react';

export const LoginCallback = () => {
  return (
    <div className="flex items-center justify-center min-h-screen">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary mx-auto mb-4"></div>
        <p className="text-muted-foreground">Completing sign in...</p>
      </div>
      <OktaLoginCallback />
    </div>
  );
};
